import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { withTranslation } from "react-i18next";

const ScheduleModule = (props) => {
  return (
    <div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0">{props.t("Current Schedule")}</h6>
        <div className="row">
          <div className="col-md-6 changeRequest_datePicker mt-1 pe-0">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  format="MM/DD/YYYY"
                  readOnly={true}
                  className="form-control"
                  slotProps={{
                    textField: {
                      error: false,
                    },
                  }}
                  value={props.schedule?.startDate?.old ? dayjs(props.schedule?.startDate.old) : dayjs(props.project?.startDate)}
                  label={props.t("Start Date")}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-1">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  format="MM/DD/YYYY"
                  readOnly={true}
                  slotProps={{
                    textField: {
                      error: false,
                    },
                  }}
                  value={props.schedule?.endDate?.old ? dayjs(props.schedule?.endDate.old) :  dayjs(props.project?.endDate)}
                  label={props.t("End Date")}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
        </div>
      </div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0 mt-2">Requested Schedule</h6>
        <div className="row">
          <div className=" col-md-6 changeRequest_datePicker mt-1 pe-0">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label={props.t("Start Date") + ' *'}
                  className="form-control"
                  format="MM/DD/YYYY"
                  name="startDate"
                  readOnly={true}
                  slotProps={{
                    textField: {
                      error: false,
                    },
                  }}
                  value={props.schedule?.startDate?.new ? dayjs(props.schedule?.startDate.new) : ''}
                  required
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-1">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label={props.t("End Date") + ' *'}
                  readOnly={true}
                  className="form-control"
                  format="MM/DD/YYYY"
                  name="endDate"
                  slotProps={{
                    textField: {
                      error: false,
                    },
                  }}
                  value={props.schedule?.endDate?.new ? dayjs(props.schedule?.endDate.new) : ''}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation() (ScheduleModule);
